import { computed } from "vue"

export function useMaskedValue(
  modelValue: () => string,
  emit: (event: "update:modelValue", value: string) => void,
  formatter: (value: string) => string,
  normalizer: (value: string) => string
) {
  const displayValue = computed(() => formatter(modelValue()))

  function handleInput(event: Event) {
    const input = event.target as HTMLInputElement
    const normalized = normalizer(input.value)
    const formatted = formatter(normalized)

    emit("update:modelValue", normalized)

    if (input.value !== formatted) {
      input.value = formatted
    }
  }

  return {
    displayValue,
    handleInput,
  }
}

